module.exports = __webpack_public_path__ + "static/img/8-1.f7c9aa57.jpg";